import React, { createContext, ReactNode, useReducer } from 'react';

interface AppProviderSchema {
  children: ReactNode;
}

export interface ActionSchema {
  type: string;
  payload: any;
}

interface AppContextType {
  store: StaticLineTableProviderSchema;
  dispatch: React.Dispatch<ActionSchema>;
}

export interface StaticLineTableProviderSchema {
  ottOptionsApi: [];
}

const intialState: StaticLineTableProviderSchema = {
  ottOptionsApi: []
};

export const actionTypes = {
  ottOptionsApi: 'OTT_OPTIONS_API'
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

const appReducer = (store: StaticLineTableProviderSchema, action: ActionSchema) => {
  switch (action.type) {
    case actionTypes?.ottOptionsApi:
      return { ...store, ottOptionsApi: action?.payload };
    default:
      return store;
  }
};

const StaticLineTableProvider = ({ children }: AppProviderSchema) => {
  const [store, dispatch] = useReducer(appReducer, intialState);
  return <AppContext.Provider value={{ store, dispatch }}>{children}</AppContext.Provider>;
};

export default StaticLineTableProvider;